import React, { useState } from "react";
import "../Category/Filters.css";

const Filters = ({ onApplyFilters }) => {
  const [priceRange, setPriceRange] = useState([0, 100]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const categories = ["Gardening", "Plants", "Seeds", "Bulbs", "Pots","Fertilizers","Corporate","Pebbles","Accessories"];

  const toggleCategory = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((cat) => cat !== category)
        : [...prev, category]
    );
  };

  const applyFilters = () => {
    onApplyFilters({
      priceRange,
      selectedCategory: selectedCategories.length ? selectedCategories : null,
    });
  };

  return (
    <div className="filters">
      <h3>Filters</h3>

      {/* Price Range Filter */}
      <div className="filter-group">
        <h4>Price Range</h4>
        <input
          type="range"
          min="0"
          max="100"
          value={priceRange[1]}
          onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
        />
        <p>
          ₹{priceRange[0]} - ₹{priceRange[1]}
        </p>
      </div>

      {/* Category Filter */}
      <div className="filter-group">
        <h4>Category</h4>
        {categories.map((category) => (
          <div key={category} className="category-checkbox">
            <input
              type="checkbox"
              id={category}
              value={category}
              checked={selectedCategories.includes(category)}
              onChange={() => toggleCategory(category)}
            />
            <label htmlFor={category}>{category}</label>
          </div>
        ))}
      </div>

      {/* Apply Filters Button */}
      <button onClick={applyFilters} className="apply-filters">
        Apply Filters
      </button>
    </div>
  );
};

export default Filters;
